import { Pipe, PipeTransform, inject } from '@angular/core';
import { I18nService } from './i18n.service';

/**
 * Usage: {{ 'inbox.mark_resolved' | t:'Mark as resolved' }}
 * With params: {{ 'inbox.unread_count' | t:'{{count}} unread':{count: n} }}
 *
 * The first argument is the stable key, the second is the English text,
 * which is shown when the key is missing from the current language.
 */
@Pipe({ name: 't', pure: false })
export class TPipe implements PipeTransform {
	private i18n = inject(I18nService);

	transform(key: string, defaultText: string, params?: Record<string, unknown>): string {
		return this.i18n.t(key, defaultText, params);
	}
}
